/**
 * Don't use it yet!
 */
appSocial.directive('scrollDetect', ['$rootScope',
    function ($rootScope) {
        return {
            restrict: 'A',
            link: function (scope, el, attrs) {
                let isScrolling = false;
                let scrollTimer;

                el.bind('scroll', (event) => {
                    this.startScroll();

                    scrollTimer = setTimeout(() => {
                        this.stopScroll();
                        clearTimeout(scrollTimer);
                    }, 500);
                });

                el.on('$destroy', () => {
                    this.stopScroll()
                    scrollTimer && clearTimeout(scrollTimer);
                    el.off('scroll');
                })

                this.startScroll = function () {
                    isScrolling = true;
                    $rootScope.$broadcast('scroll.start');
                };

                this.stopScroll = function () {
                    isScrolling = false;
                    $rootScope.$broadcast('scroll.stop');
                };
            }
        }
    }
])
